import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ServerDashboardJob } from '../../dashboardType';
import { formatUserEmail } from '../../utils/formatUserEmail';

const StoppedByCell = (
  properties: CustomCellRendererProps<ServerDashboardJob>
) => {
  const email = properties.data?.stoppedByPersonEmailID;

  if (!email) {
    return null;
  }

  return <span>{formatUserEmail(email)}</span>;
};

export default StoppedByCell;
